import profile from './Assets/ProfilePicture.png'
import html from './Assets/html.png'
import css from './Assets/css.png'
import js from './Assets/js.png'
import ts from './Assets/ts.png'
import python from './Assets/python.png'
import cpp from './Assets/c++.png'
import c from './Assets/c.png'
import react from './Assets/react.png'
import vue from './Assets/vue.png'
import mui from './Assets/mui.png'
import node from './Assets/node.png'
import express from './Assets/express.png'
import firebase from './Assets/firebase.png'
import mongo from './Assets/mongo.png'
import puppeteer from './Assets/puppeteer.png'
import git from './Assets/git.png'
import jest from './Assets/jest.png'
import rmq from './Assets/rmq.png'
import solidworks from './Assets/solidworks.png'
import heroku from './Assets/heroku.png'
import csharp from './Assets/csharp.png'
import chakraui from './Assets/chakraui.png'
import dotnet from './Assets/dotnet.png'
import graphql from './Assets/graphql.png'
import apollo from './Assets/apollo.png'
import resume from './Assets/resume.pdf'
import django from './Assets/django.png'
import docker from './Assets/docker.png'
import kubernetes from './Assets/kubernetes.png'

export const links = {
	default: profile,
	HTML: html,
	CSS: css,
	Javascript: js,
	Typescript: ts,
	Python: python,
	C: c,
	"C++": cpp,
	React: react,
	Vue: vue,
	"Material-UI": mui,
	Node: node,
	Express: express,
	Firebase: firebase,
	MongoDB: mongo,
	Puppeteer: puppeteer,
	Git: git,
	Jest: jest,
	RabbitMQ: rmq,
	SolidWorks: solidworks,
	Heroku: heroku,
	Resume: resume,
	"C#": csharp,
	"Chakra-UI": chakraui,
	GraphQL: graphql,
	Apollo: apollo,
	".NET": dotnet,
	Django: django,
	Docker: docker,
	Kubernetes: kubernetes,
	Github: "https://github.com/NirmalHegde",
	LinkedIn: "https://www.linkedin.com/in/nirmalhegde"
}